module.exports = __webpack_public_path__ + "a58238f3332d5b56a90971095d7a3a75.svg";